<div class="phx-table-header-content">
  <div class="phx-table-header-label-container">
    <ng-container *ngFor="let header of headerViews; let last = last">
      <span
        class="phx-table-header-label"
        [class.phx-web-type-body-extra-small-emphasis]="!phxColumn.headerTooltipContent"
        [class.phx-web-type-body-extra-small-emphasis-dotted]="phxColumn.headerTooltipContent"
        [class.phx-table-header-label-sortable]="header.sortable"
        [class.phx-table-header-label-active]="header.sortActive"
        [attr.tabindex]="header.sortable ? 0 : null"
        [attr.role]="header.sortable ? 'button' : null"
        phx-tooltip
        [phxContent]="phxColumn.headerTooltipContent || null"
        (click)="onSortClick(header.config)"
        (keydown)="header.sortable && onSortKeydown($event, header.config)"
        >{{ header.label }}</span
      >
      <span *ngIf="!last" class="phx-table-header-separator">/</span>
    </ng-container>
  </div>

  <button
    *ngIf="columnSortable"
    class="phx-table-sort-icon"
    phx-icon-button
    [phxIcon]="columnSortIcon"
    [phxIconButtonSize]="'extra-extra-small'"
    [class.phx-table-sort-icon-active]="columnSortActive"
    (click)="onSortArrowClick()"
  ></button>
</div>
